"use strict";import{tag as a}from"../custom-tag.js";export function closedCaptionIcon({height:e=16,width:l=16,hidden:t=!1,title:r="Closed caption"}={}){return a`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${l}
      height=${e}
      aria-hidden="${t?"true":"false"}"
      role="img"
      aria-label="${r}"
    >
      <path
        fill="currentColor"
        d="M8.39 12c-.35.34-.8.51-1.34.51-.56 0-1.02-.19-1.37-.57-.42-.45-.63-1.1-.63-1.96 0-.77.17-1.38.5-1.82.36-.48.88-.72 1.55-.72.45 0 .83.12 1.15.34.35.25.56.61.62 1.07h.9a2.1 2.1 0 0 0-.7-1.42A2.76 2.76 0 0 0 7.1 6.7c-.83 0-1.5.25-2.02.74-.62.58-.94 1.43-.94 2.54q0 1.455.69 2.31c.52.65 1.25.97 2.2.97.51 0 .98-.11 1.41-.34.4-.2.71-.5.95-.86.24-.35.37-.74.39-1.15h-.9a1.6 1.6 0 0 1-.5 1.08Zm6.21 0c-.36.34-.8.51-1.35.51-.56 0-1.01-.19-1.36-.57-.42-.45-.63-1.1-.63-1.96 0-.77.16-1.38.5-1.82.36-.48.87-.72 1.54-.72.45 0 .84.12 1.15.34.36.25.56.61.62 1.07h.9a2.1 2.1 0 0 0-.7-1.42 2.76 2.76 0 0 0-1.97-.73c-.82 0-1.5.25-2.02.74-.62.58-.93 1.43-.93 2.54 0 .97.22 1.74.68 2.31.52.65 1.25.97 2.2.97.52 0 .99-.11 1.41-.34.4-.2.72-.5.96-.86.23-.35.36-.74.38-1.15h-.9a1.6 1.6 0 0 1-.49 1.08Z"
      />
      <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M0 3.75h20v12.5H0zm1 1h18v10.5H1z"
        clip-rule="evenodd"
      />
    </svg>
  `}
//# sourceMappingURL=closedCaption.js.map
